<template lang="html">
  <div>
    Error - Page Not Found
  </div>
</template>
<script>
export default {}
</script>
<style lang="scss">
</style>
